import React, { useState } from 'react';
import { Search } from 'chic-ui';
import { Row } from 'react-bootstrap';

const SearchComponent = () => {
  const [value, setValue] = useState('');
  return (
    <div className="m-3">
      <h3>Search</h3>
      <p>
        Search is a simple component derived from the <i>Text Input </i>
        component and <i>Button</i> component.
        <br />
        Implementation is given below:
      </p>
      <div className="mt-5">
      <Search
        placeholder="Search something..."
        width="400px"
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        />
        </div>
      <Row className="mt-5">
        <code>
          {'import React, { useState } from "react";'}
          <br />
          {'import { Search } from "chic-ui";'}
          <br />
          {'const [value, setValue] = useState("");'}
          <br />
          {'<Search placeholder="Search something..." width="400px" value={value} onChange={(e) => setValue(e.currentTarget.value)} />'}
        </code>
      </Row>
    </div>
  );
};

export default SearchComponent;
